import { render, staticRenderFns } from "./RelativeUsersPage.vue?vue&type=template&id=dfeb7a18&"
import script from "./RelativeUsersPage.vue?vue&type=script&lang=js&"
export * from "./RelativeUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports